import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityBeaconNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12 14.175a3.18 3.18 0 11-.013-6.36 3.18 3.18 0 01.013 6.36zm0-5a1.825 1.825 0 100 3.65 1.825 1.825 0 000-3.65zm-6.582 5.89a7.789 7.789 0 01.059-8.138l1.144.715a6.44 6.44 0 00-.049 6.724zm13.164 0l-1.154-.7a6.44 6.44 0 00-.049-6.724l1.144-.715a7.79 7.79 0 01.059 8.138zM1.919 16.938a11.665 11.665 0 01.066-11.884l1.157.7a10.315 10.315 0 00-.057 10.508zm20.162 0l-1.166-.68a10.316 10.316 0 00-.057-10.508l1.157-.7a11.665 11.665 0 01.066 11.884zm-4.558 5.737H6.477l-.714-1.324a3.418 3.418 0 013.01-5.026h6.454a3.417 3.417 0 013.011 5.022zm-10.24-1.35h9.434l.332-.615a2.065 2.065 0 00-1.822-3.035H8.773a2.068 2.068 0 00-1.82 3.039z"
        fill=""
      />
    </svg>
  )
);
SvgActivityBeaconNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActivityBeaconNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityBeaconNormalSmall;
